import { BaseType } from '../../base/base-type';
import { MemberStatusTypeEnum } from '../enum/member-status-type-enum';

export class MemberStatusType extends BaseType {
  public declare id: MemberStatusTypeEnum;
}
